import { isArray } from "@/libs/utils";
import { usePermissionStoreWithOut } from '@/store/modules/permission';

/**
 * v-auth 权限认证
 * @param el 
 * @param binding 
 */
const checkAuth = (el, binding) => {
    const { value }         = binding;
    const permissionStore   = usePermissionStoreWithOut();
    const auth              = permissionStore.auth;
    const purview           = '*';
    if(isArray(auth) && value.length > 0){
        const isAuth = auth.some((key)=>{
            return purview == key || value.includes(key);
        });
        
        if(!isAuth){
            el.parentNode && el.parentNode.removeChild(el);
        }
    }else{
        throw new Error('v-auth="[\'user/editor\']"')
    }
}

export default {
    mounted(el, binding) {
        checkAuth(el, binding)
    },
    // updated(el, binding) {
    //     checkAuth(el, binding)
    // }
};